<template>
    <section :id="id" class="relative overflow-x-hidden" :class="{ hidden: !loading && (!recipes || recipes.length === 0) }">
        <div class="container flex flex-col gap-md">
            <div key="loading" class="flex col-span-12 justify-center" v-if="loading">
                <div class="aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                    <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
                </div>
            </div>
            <template v-else-if="recipes && recipes.length">
                <slot name="before"></slot>
                <div class="flex flex-col sm:flex-row gap-sm md:gap-md featured-grid sm:[&>*:nth-child(4)]:hidden lg:[&>*:nth-child(4)]:block">
                    <div class="featured-grid__item" v-for="(item, index) in recipes" :key="index">
                        <a :href="`${possibleLangPrefix}/recepten/${item.slug}`" class="block">
                            <div class="flex flex-col sm:h-[380px] md:h-[600px]">
                                <div class="w-full h-full relative" v-if="item.media.length > 0">
                                    <div class="relative h-[300px] sm:absolute top-0 left-0 w-full sm:h-full">
                                        <img :data-src="item.media[0].url" :alt="item.title" class="w-full h-full object-cover lazyload" />
                                    </div>
                                </div>
                                <div class="shrink-0 relative overflow-hidden | featured-grid__item-title">
                                    <div class="flex items-center justify-between my-sm sm:my-md">
                                        <h3 class="">
                                            {{ item.title }}
                                        </h3>
                                        <div class="w-lg h-lg rounded-full border border-primary-400 shrink-0 ml-sm text-primary-400 flex items-center justify-center">
                                            <i class="fa-regular fa-arrow-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <slot name="after"></slot>
            </template>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

export default {
    name: 'recipeshighlight',

    props: ['recipeslugs', 'id', 'currentBook', 'mode'],

    data() {
        return {
            recipes: [],
            loading: false,
        };
    },

    mounted() {
        this.getRecipes();
    },

    methods: {
        getRecipes() {
            this.loading = true;

            //?q[and][open_recipe.source_book.title]=Ik%20eet%20zo%20graag%20&per_page=4&s[open_recipe.source_book.X-publish_date]=desc&s[slug]=asc
            const query = this.buildQueryObject();
            const queryString = qs.stringify(query, { encode: false });

            axios
                .get(`/api/my-recipes?${queryString}`)
                .then((response) => {
                    if (response.status === 200) {
                        let recipes = [];

                        if (this.recipeslugs.length) {
                            this.recipeslugs.forEach((rs) => {
                                const matchedRecipe = response.data.data.find((r) => r.slug === rs);
                                if (matchedRecipe) {
                                    recipes.push(matchedRecipe);
                                }
                            });
                        } else {
                            recipes = response.data.data;
                        }

                        this.recipes = recipes;
                    } else {
                        this.recipes = [];
                    }
                })
                .finally(() => (this.loading = false));
        },

        buildQueryObject() {
            let query = {};

            if (this.recipeslugs.length) {
                query.slugs = this.recipeslugs.join();
            }

            if (this.mode === 'random') {
                query.s = {
                    id: 'asc',
                };
                query.after = Math.floor(Math.random() * (1000 - 1 + 1) + 1);
            }

            if (this.mode === 'last') {
                query.q = {
                    and: {
                        enrichment_id: 'exists:',
                    },
                };
            }

            if (this.mode === 'current_book' && this.currentBook && this.currentBook !== '') {
                query.q = {
                    and: {
                        'open_recipe.source_book.title': this.currentBook,
                        enrichment_id: 'exists:',
                    },
                };
            }

            query.per_page = 4;
            query.page = 1;

            return query;
        },
    },

    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '';
        },
    },
};
</script>
